module.exports = __webpack_public_path__ + "img/IMG_5919.e4c77b7b.jpg";